module.exports = __webpack_public_path__ + "img/IMG_9257_T_L_Wood.c02b38dc.jpg";